<template>
  <DxPopup @hidden="onHidden" :visible="showFail" :show-close-button="true" :show-title="true" :title="'Login Fail'" height="384px" width="640px" container=".v-application">
    <div class="text-center pb-4" style="font-weight: bold; font-size: 28px;">
      <v-icon large class="mt-n2" color="red">
        mdi-check
      </v-icon>
      Login Fail
    </div>

    <div class="text-center pb-4" style="font-size: 20px;">
      1. Incorrect password or unknown user.
    </div>

    <div class="text-center pb-1" style="font-size: 20px;">
      2. You didn't agree with: 
      <span style="color: red;">
        HVS CODE OF CONDUCT & COMPLY FROM SUPPLIERS.
      </span>
    </div>

    <div class="text-center" style="font-size: 20px;">
      Please check it again.
    </div>
  </DxPopup>
</template>

<script>
import { DxPopup } from 'devextreme-vue/popup'

export default {
  components: {
    DxPopup
  },
  props: {
    showFail: {
      type: Boolean,
      default() {
        return false
      }
    }
  },
  methods: {
    onHidden(e) {
      this.$emit('update:showFail', false)
    }
  }
}
</script>

<style lang="scss" scoped>

</style>